"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/internal_common.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalOrderLineItemGoodsSelfShipping = exports.InternalOrderLineItemGoodsDigital = exports.InternalOrderLineItemBackNumber = exports.InternalOrderLineItemPlan = exports.InternalOrderLineItem = exports.InternalOrder = exports.InternalBankAccount = exports.InternalOrderFinancialStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * https://github.com/balus-co-ltd/spwn/blob/38e7f14d735dfd5ba5a16acb6cd6c56876bb3c73/main/packages/bff/src/dto/fanClubOrderHistoryItem.ts#L30-L42
 *
 * @generated from enum spwn.order.v1.InternalOrderFinancialStatus
 */
var InternalOrderFinancialStatus;
(function (InternalOrderFinancialStatus) {
    /**
     * @generated from enum value: INTERNAL_ORDER_FINANCIAL_STATUS_UNSPECIFIED = 0;
     */
    InternalOrderFinancialStatus[InternalOrderFinancialStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 未支払い
     *
     * @generated from enum value: INTERNAL_ORDER_FINANCIAL_STATUS_PENDING = 1;
     */
    InternalOrderFinancialStatus[InternalOrderFinancialStatus["PENDING"] = 1] = "PENDING";
    /**
     * 支払い済み
     *
     * @generated from enum value: INTERNAL_ORDER_FINANCIAL_STATUS_PAID = 2;
     */
    InternalOrderFinancialStatus[InternalOrderFinancialStatus["PAID"] = 2] = "PAID";
    /**
     * 返金済み
     *
     * @generated from enum value: INTERNAL_ORDER_FINANCIAL_STATUS_REFUNDED = 3;
     */
    InternalOrderFinancialStatus[InternalOrderFinancialStatus["REFUNDED"] = 3] = "REFUNDED";
    /**
     * 支払い前に取り消し済み
     *
     * @generated from enum value: INTERNAL_ORDER_FINANCIAL_STATUS_VOIDED = 4;
     */
    InternalOrderFinancialStatus[InternalOrderFinancialStatus["VOIDED"] = 4] = "VOIDED";
})(InternalOrderFinancialStatus = exports.InternalOrderFinancialStatus || (exports.InternalOrderFinancialStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(InternalOrderFinancialStatus)
protobuf_1.proto3.util.setEnumType(InternalOrderFinancialStatus, "spwn.order.v1.InternalOrderFinancialStatus", [
    { no: 0, name: "INTERNAL_ORDER_FINANCIAL_STATUS_UNSPECIFIED" },
    { no: 1, name: "INTERNAL_ORDER_FINANCIAL_STATUS_PENDING" },
    { no: 2, name: "INTERNAL_ORDER_FINANCIAL_STATUS_PAID" },
    { no: 3, name: "INTERNAL_ORDER_FINANCIAL_STATUS_REFUNDED" },
    { no: 4, name: "INTERNAL_ORDER_FINANCIAL_STATUS_VOIDED" },
]);
/**
 * @generated from message spwn.order.v1.InternalBankAccount
 */
class InternalBankAccount extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 銀行名
         *
         * @generated from field: string bank_name = 1;
         */
        this.bankName = "";
        /**
         * 支店名
         *
         * @generated from field: string branch_name = 2;
         */
        this.branchName = "";
        /**
         * 口座種別
         *
         * @generated from field: string account_type = 3;
         */
        this.accountType = "";
        /**
         * 口座番号
         *
         * @generated from field: string account_number = 4;
         */
        this.accountNumber = "";
        /**
         * 口座名義（カナ）
         *
         * @generated from field: string account_holder_kana = 5;
         */
        this.accountHolderKana = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalBankAccount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalBankAccount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalBankAccount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalBankAccount, a, b);
    }
}
exports.InternalBankAccount = InternalBankAccount;
InternalBankAccount.runtime = protobuf_1.proto3;
InternalBankAccount.typeName = "spwn.order.v1.InternalBankAccount";
InternalBankAccount.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bank_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "account_holder_kana", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * ユーザーが注文し、支払いを行う単位
 * 買い合せできる商品の組み合わせを制限しないために、商品の種類ごとの InternalOrder を定義せず共通のメッセージを使用する。
 *
 * @generated from message spwn.order.v1.InternalOrder
 */
class InternalOrder extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * 注文番号
         *
         * @generated from field: string order_number = 2;
         */
        this.orderNumber = "";
        /**
         * 支払い状況
         *
         * @generated from field: spwn.order.v1.InternalOrderFinancialStatus financial_status = 3;
         */
        this.financialStatus = InternalOrderFinancialStatus.UNSPECIFIED;
        /**
         * 注文に含まれる商品
         *
         * @generated from field: repeated spwn.order.v1.InternalOrderLineItem line_items = 4;
         */
        this.lineItems = [];
        /**
         * 商品の合計金額
         *
         * @generated from field: int32 total_item_amount = 5;
         */
        this.totalItemAmount = 0;
        /**
         * 配送料
         *
         * @generated from field: int32 total_shipping_fee_amount = 6;
         */
        this.totalShippingFeeAmount = 0;
        /**
         * 合計金額
         *
         * @generated from field: int32 total_payment_amount = 7;
         */
        this.totalPaymentAmount = 0;
        /**
         * 注文日時
         *
         * @generated from field: int64 ordered_at = 8;
         */
        this.orderedAt = protobuf_1.protoInt64.zero;
        /**
         * 注文者のユーザID
         *
         * @generated from field: string user_id = 12;
         */
        this.userId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrder, a, b);
    }
}
exports.InternalOrder = InternalOrder;
InternalOrder.runtime = protobuf_1.proto3;
InternalOrder.typeName = "spwn.order.v1.InternalOrder";
InternalOrder.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "financial_status", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalOrderFinancialStatus) },
    { no: 4, name: "line_items", kind: "message", T: InternalOrderLineItem, repeated: true },
    { no: 5, name: "total_item_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "total_shipping_fee_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "total_payment_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "ordered_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "paid_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "canceled_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.InternalOrderLineItem
 */
class InternalOrderLineItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.order.v1.InternalOrderLineItem.line_item
         */
        this.lineItem = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrderLineItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrderLineItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrderLineItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrderLineItem, a, b);
    }
}
exports.InternalOrderLineItem = InternalOrderLineItem;
InternalOrderLineItem.runtime = protobuf_1.proto3;
InternalOrderLineItem.typeName = "spwn.order.v1.InternalOrderLineItem";
InternalOrderLineItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 3, name: "digital_goods", kind: "message", T: InternalOrderLineItemGoodsDigital, oneof: "line_item" },
    { no: 4, name: "self_shipping_goods", kind: "message", T: InternalOrderLineItemGoodsSelfShipping, oneof: "line_item" },
]);
/**
 * @generated from message spwn.order.v1.InternalOrderLineItemPlan
 */
class InternalOrderLineItemPlan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string plan_id = 2;
         */
        this.planId = "";
        /**
         * @generated from field: int32 quantity = 3;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrderLineItemPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrderLineItemPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrderLineItemPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrderLineItemPlan, a, b);
    }
}
exports.InternalOrderLineItemPlan = InternalOrderLineItemPlan;
InternalOrderLineItemPlan.runtime = protobuf_1.proto3;
InternalOrderLineItemPlan.typeName = "spwn.order.v1.InternalOrderLineItemPlan";
InternalOrderLineItemPlan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.InternalOrderLineItemBackNumber
 */
class InternalOrderLineItemBackNumber extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string plan_id = 2;
         */
        this.planId = "";
        /**
         * @generated from field: int32 back_number_year = 3;
         */
        this.backNumberYear = 0;
        /**
         * @generated from field: int32 back_number_month = 4;
         */
        this.backNumberMonth = 0;
        /**
         * @generated from field: int32 quantity = 5;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrderLineItemBackNumber().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrderLineItemBackNumber().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrderLineItemBackNumber().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrderLineItemBackNumber, a, b);
    }
}
exports.InternalOrderLineItemBackNumber = InternalOrderLineItemBackNumber;
InternalOrderLineItemBackNumber.runtime = protobuf_1.proto3;
InternalOrderLineItemBackNumber.typeName = "spwn.order.v1.InternalOrderLineItemBackNumber";
InternalOrderLineItemBackNumber.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "back_number_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "back_number_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.InternalOrderLineItemGoodsDigital
 */
class InternalOrderLineItemGoodsDigital extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string goods_id = 2;
         */
        this.goodsId = "";
        /**
         * @generated from field: string goods_variant_id = 3;
         */
        this.goodsVariantId = "";
        /**
         * @generated from field: int32 quantity = 4;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrderLineItemGoodsDigital().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrderLineItemGoodsDigital().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrderLineItemGoodsDigital().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrderLineItemGoodsDigital, a, b);
    }
}
exports.InternalOrderLineItemGoodsDigital = InternalOrderLineItemGoodsDigital;
InternalOrderLineItemGoodsDigital.runtime = protobuf_1.proto3;
InternalOrderLineItemGoodsDigital.typeName = "spwn.order.v1.InternalOrderLineItemGoodsDigital";
InternalOrderLineItemGoodsDigital.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.InternalOrderLineItemGoodsSelfShipping
 */
class InternalOrderLineItemGoodsSelfShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string goods_id = 2;
         */
        this.goodsId = "";
        /**
         * @generated from field: string goods_variant_id = 3;
         */
        this.goodsVariantId = "";
        /**
         * @generated from field: int32 quantity = 4;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrderLineItemGoodsSelfShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrderLineItemGoodsSelfShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrderLineItemGoodsSelfShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrderLineItemGoodsSelfShipping, a, b);
    }
}
exports.InternalOrderLineItemGoodsSelfShipping = InternalOrderLineItemGoodsSelfShipping;
InternalOrderLineItemGoodsSelfShipping.runtime = protobuf_1.proto3;
InternalOrderLineItemGoodsSelfShipping.typeName = "spwn.order.v1.InternalOrderLineItemGoodsSelfShipping";
InternalOrderLineItemGoodsSelfShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
//# sourceMappingURL=internal_common_pb.js.map